export default {
  "site.name": "USFansSheet",
  "site.tagline": "Explorez, comparez et organisez la USFans Spreadsheet",
  "seo.homeTitle": "USFans Spreadsheet – Explorez, comparez et organisez vos ressources",
  "seo.homeDesc": "USFansSheet est un hub clair et utile dédié à la USFans Spreadsheet. Parcourez les catégories, lisez des guides et comparatifs originaux, puis achetez sur le site principal.",
  "seo.guideTitle": "USFans Spreadsheet – Le guide complet",
  "seo.guideDesc": "Découvrez ce qu'est une USFans Spreadsheet, comment l'utiliser et quoi vérifier dans ce guide original et détaillé avec comparatifs et FAQ.",

  "nav.home": "Accueil",
  "nav.guide": "Guide d'achat",
  "nav.categories": "Catégories",
  "nav.faq": "FAQ",
  "nav.buy": "Acheter maintenant",
  "nav.visitMain": "Visiter le site principal",

  "hero.eyebrow": "Hub de ressources USFans Spreadsheet",
  "hero.title": "Explorez, comparez et organisez la USFans Spreadsheet",
  "hero.subtitle": "USFansSheet est un hub clair et utile construit autour de la USFans Spreadsheet. Parcourez des catégories organisées, lisez des guides pratiques et comparez les ressources, puis rendez-vous sur le site principal pour tout acheter au même endroit.",
  "hero.trust": "Ressource indépendante · Mise à jour régulièrement · Axée confidentialité et sécurité",
  "hero.cta.main": "USFans Spreadsheet",
  "hero.cta.buy": "Acheter maintenant",
  "hero.cta.guide": "Lire le guide",

  "what.title": "Qu'est-ce qu'une USFans Spreadsheet ?",
  "what.text1": "Une USFans Spreadsheet est une façon structurée d'organiser et de consulter des informations sur les créateurs et les produits dans une seule vue consultable. Au lieu de sauter entre des pages dispersées, une ressource en forme de tableur rassemble tout pour qu'il soit plus facile de parcourir, comparer et comprendre.",
  "what.text2": "USFansSheet est construit autour de ce sujet. Nous publions des guides, comparatifs et FAQ originaux qui vous aident à comprendre les ressources disponibles, et nous vous dirigeons vers le site principal où vous pouvez parcourir le catalogue complet.",
  "what.cta": "Explorer le guide du tableur",

  "categories.title": "Parcourir par catégorie",
  "categories.subtitle": "Accédez directement à la collection que vous cherchez sur le site principal.",
  "drop.label": "Choisir une catégorie",
  "drop.hint": "Sélectionnez une catégorie pour continuer",

  "cat.shoes": "Chaussures",
  "cat.hoodies": "Sweats / Pulls",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons / Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements / Caleçons",
  "cat.jersey": "Maillot",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",

  "features.title": "Pourquoi USFansSheet",
  "features.1.title": "Organisé",
  "features.1.text": "Tout est regroupé dans des catégories claires, pour que vous trouviez ce qu'il vous faut sans fouiller des pages dispersées.",
  "features.2.title": "Facile à comparer",
  "features.2.text": "Utilisez des guides structurés et des tableaux comparatifs simples pour peser vos options avant de cliquer.",
  "features.3.title": "Sûr et utile",
  "features.3.text": "Nous restons clairs, honnêtes et concentrés sur le fait de vous aider à prendre de meilleures décisions, sans bruit ni pièges.",

  "compare.title": "USFans Spreadsheet face à la recherche traditionnelle",
  "compare.colFeature": "Fonctionnalité",
  "compare.colA": "Tableur",
  "compare.colB": "Recherche traditionnelle",
  "compare.row1.f": "Informations structurées",
  "compare.row1.a": "Oui",
  "compare.row1.b": "Limité",
  "compare.row2.f": "Comparaison facile",
  "compare.row2.a": "Oui",
  "compare.row2.b": "Limité",
  "compare.row3.f": "Organisation",
  "compare.row3.a": "Élevée",
  "compare.row3.b": "Faible",
  "compare.row4.f": "Filtrage",
  "compare.row4.a": "Possible",
  "compare.row4.b": "Limité",
  "compare.row5.f": "Adapté aux débutants",
  "compare.row5.a": "Oui",
  "compare.row5.b": "Moyen",
  "compare.row6.f": "Ressources spécifiques au sujet",
  "compare.row6.a": "Oui",
  "compare.row6.b": "Mixte",

  "articlePromo.title": "Lisez le guide complet de la USFans Spreadsheet",
  "articlePromo.text": "Nouveau sur le sujet ? Notre guide détaillé explique ce qu'est une USFans Spreadsheet, comment l'utiliser et quoi vérifier, le tout dans un seul article original.",
  "articlePromo.cta": "Ouvrir le guide",

  "faq.title": "Questions fréquentes",
  "faq.q1": "Qu'est-ce qu'une USFans Spreadsheet ?",
  "faq.a1": "C'est une façon structurée et consultable d'organiser des informations sur les créateurs et les produits dans une seule vue, ce qui facilite la lecture, la comparaison et la compréhension.",
  "faq.q2": "USFansSheet est-il le site officiel d'USFans ?",
  "faq.a2": "Non. USFansSheet est une ressource informative indépendante. Pour le catalogue complet, visitez le site principal.",
  "faq.q3": "Où puis-je parcourir les produits ?",
  "faq.a3": "Utilisez le menu des catégories ci-dessus ou visitez directement le site principal. Chaque catégorie mène à sa section correspondante.",
  "faq.q4": "Vendez-vous des produits sur ce site ?",
  "faq.a4": "Non. Ce site propose des guides et des ressources. Tous les produits sont disponibles sur le site principal.",
  "faq.q5": "Mes informations sont-elles en sécurité ?",
  "faq.a5": "Nous ne collectons ni données personnelles ni données de paiement. Vérifiez toujours les informations importantes et évitez les liens suspects.",
  "faq.q6": "À quelle fréquence le contenu est-il mis à jour ?",
  "faq.a6": "Nous révisons et actualisons régulièrement nos guides, mais les prix, les stocks et la livraison peuvent changer : vérifiez toujours les détails actuels sur le site principal.",

  "article.h1": "USFans Spreadsheet : le guide complet",
  "article.short": "Une USFans Spreadsheet est une ressource structurée et consultable qui organise les informations sur les créateurs et les produits en un seul endroit, facilitant la navigation, la comparaison et la compréhension. Ce guide explique comment elle fonctionne et quoi vérifier.",
  "article.intro": "Si vous êtes tombé sur le terme « USFans Spreadsheet » et souhaitez comprendre ce qu'il signifie vraiment et comment l'utiliser, vous êtes au bon endroit. Ce guide explique l'idée en langage simple, montre quoi vérifier et vous aide à tirer le meilleur de ces ressources. Nous vous indiquons aussi où trouver le catalogue complet sur le site principal.",
  "article.toc.title": "Sommaire",
  "article.toc.1": "Qu'est-ce qu'une USFans Spreadsheet ?",
  "article.toc.2": "Pourquoi les gens utilisent un tableur",
  "article.toc.3": "Comment utiliser une USFans Spreadsheet",
  "article.toc.4": "Tableur face à la recherche traditionnelle",
  "article.toc.5": "Que rechercher dans une bonne ressource",
  "article.toc.6": "Questions fréquentes",
  "article.s1.title": "Qu'est-ce qu'une USFans Spreadsheet ?",
  "article.s1.p": "Une USFans Spreadsheet est une façon structurée d'organiser les informations sur les créateurs et les produits dans une seule vue consultable. Pensez-y comme à un tableau propre qui regroupe des éléments liés — noms, catégories, liens et détails — pour que vous puissiez tout parcourir d'un coup d'œil au lieu de cliquer sur de nombreuses pages séparées. L'objectif est simple : faciliter la recherche, la comparaison et la compréhension des informations.",
  "article.s2.title": "Pourquoi les gens utilisent un tableur",
  "article.s2.p": "Les tableurs sont populaires pour une raison simple : ils réduisent l'effort de recherche. Lorsque les informations sont réparties sur de nombreuses pages, trouver et comparer les options prend du temps. Un tableur bien organisé rassemble les éléments liés en un seul endroit, pour que vous voyiez des tendances, repériez les différences et décidiez plus vite. Pour un sujet comme USFans, avec de nombreuses catégories et ressources, cette structure est particulièrement utile.",
  "article.s3.title": "Comment utiliser une USFans Spreadsheet",
  "article.s3.intro": "Voici une façon simple de commencer, étape par étape :",
  "article.s3.1": "Commencez par les catégories : la plupart des tableurs regroupent les éléments par catégorie, comme Chaussures, Sweats / Pulls, T-shirts, Vestes et plus encore. Commencez par le groupe qui correspond à ce que vous cherchez.",
  "article.s3.2": "Parcourez et comparez : regardez les lignes et les colonnes pour comparer les noms, les détails et les liens côte à côte.",
  "article.s3.3": "Suivez la source : un bon tableur renvoie vers la source originale. Utilisez ces liens pour vérifier les détails et voir l'ensemble.",
  "article.s3.4": "Vérifiez avant d'agir : les prix, les stocks et la livraison peuvent changer. Consultez toujours les informations les plus récentes sur le site principal.",
  "article.s4.title": "Tableur face à la recherche traditionnelle",
  "article.s5.title": "Que rechercher dans une bonne ressource",
  "article.s5.p": "Tous les tableurs ne se valent pas. Une bonne ressource est clairement organisée, facile à lire et renvoie vers une source fiable. Elle doit être mise à jour régulièrement et ne jamais vous mettre la pression. Surtout, elle doit respecter votre vie privée et ne jamais demander de mots de passe, de données de paiement ni d'autres informations sensibles. Si une ressource le demande, considérez-le comme un signal d'alerte et partez.",
  "article.related": "Vous en voulez plus ? Revenez à la page d'accueil pour parcourir toutes les catégories et ressources, ou lisez des guides connexes sur notre site principal.",
  "article.back": "Retour à la page d'accueil",
  "article.cta": "Parcourir le catalogue complet sur le site principal",
  "article.meta.author": "Équipe éditoriale USFansSheet",
  "article.meta.date": "Mis à jour régulièrement",

  "footer.desc": "Une ressource indépendante et utile construite autour de la USFans Spreadsheet. Parcourez les catégories, lisez des guides et rendez-vous sur le site principal pour tout acheter au même endroit.",
  "footer.resources": "Ressources",
  "footer.resources.guide": "Guide du tableur",
  "footer.resources.categories": "Catégories",
  "footer.resources.faq": "FAQ",
  "footer.main": "Site principal",
  "footer.main.desc": "Visitez le site principal pour parcourir le catalogue complet.",
  "footer.disclaimer": "USFansSheet est une ressource informative indépendante et n'est pas affiliée au site principal. Tous les produits et achats sont gérés sur le site principal.",
  "footer.copyright": "© 2026 USFansSheet. Tous droits réservés.",

  "resources.title": "Explorez les ressources USFans",
  "resources.subtitle": "Guides et références utiles pour naviguer, comparer et acheter en confiance.",
  "res.learnMore": "En savoir plus",
  "res.spreadsheet.title": "USFans Spreadsheet",
  "res.spreadsheet.text": "Guides structurés pour explorer et organiser les ressources des créateurs.",
  "res.directory.title": "Annuaire de créateurs",
  "res.directory.text": "Comprenez comment fonctionnent les annuaires et listes de créateurs.",
  "res.reviews.title": "Avis",
  "res.reviews.text": "Ce qu'il faut vérifier avant d'acheter, expliqué honnêtement.",
  "res.comparisons.title": "Comparatifs",
  "res.comparisons.text": "Comparez les ressources côte à côte pour décider plus vite.",
  "res.safety.title": "Centre de sécurité",
  "res.safety.text": "Conseils de confidentialité, sécurité du compte et usage responsable.",
  "res.guides.title": "Guides",
  "res.guides.text": "Tutoriels pratiques pour débutants et utilisateurs avancés.",

  "articles.title": "Guides piliers USFans",
  "articles.subtitle": "Dix guides originaux sur les sujets les plus recherchés.",
  "articles.read": "Lire le guide",
  "articles.related": "Guides connexes",

  "article.notFound": "Article introuvable",
};